import { GET_REPORT_DETAILS } from "../../Utils/types";

const initialState = {
  getReportDetails: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_DETAILS:
      return {
        ...state,
        getReportDetails: action.payload,
      };
    default:
      return state;
  }
};
